import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import CommentsList from '../../comments/CommentsList';
import CommentsHeader from './CommentsHeader';
import NotAuthenticatedPanel from '../../comments/NotAuthenticatedPanel';
import PostCommentField from '../../comments/PostCommentField';
import NotAllowedCommentsPanel from '../../comments/NotAllowedCommentsPanel';
import comments from '../../comments/comment-notifications';

class CommentsPanel extends React.Component {
    componentDidMount () {
        comments.commentsInPresentations().subscribe();
    }

    componentWillUnmount () {
        comments.commentsInPresentations().unsubscribe();
    }

    render () {
        const expanded = this.props.store.ui.comments ? 'expanded' : '';
        const inverted = this.props.isInPreview
            ? 'ib-comments-preview theme-dark'
            : 'ib-comments-editor theme-light';

        return <div
            className={`comments-section presentation-comments ${expanded} ${inverted}`}
        >
            <CommentsHeader
                commentsStore={this.props.store.comments}
                allowComments={this.props.store.allowComments}
            />
            {
                Settings.user.isAuthenticated
                    ? this.props.store.allowComments
                        ? <PostCommentField commentsStore={this.props.store.comments} />
                        : <NotAllowedCommentsPanel />
                    : <NotAuthenticatedPanel />
            }
            <CommentsList commentsStore={this.props.store.comments}/>
        </div>;
    }
}
CommentsPanel.propTypes = {
    store: PropTypes.object.isRequired,
    isInPreview: PropTypes.bool
};

export default observer(CommentsPanel);
